var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVariableDistributedLoadW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 123,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2703 -1735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 108.93 67.65",
    stroke: "#FFFFFF",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 2731.5 1805.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2841.22 1737.5 2841.22 1806.98 2837.78 1806.98 2837.78 1737.5ZM2853.25 1802.4 2839.5 1829.9 2825.75 1802.4Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2745.25 1802.5 2731.5 1830 2717.75 1802.5Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2770.22 1782.5 2770.22 1805.78 2766.78 1805.78 2766.78 1782.5ZM2782.25 1801.2 2768.5 1828.7 2754.75 1801.2Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2806.22 1762.5 2806.22 1805.58 2802.78 1805.58 2802.78 1762.5ZM2818.25 1801 2804.5 1828.5 2790.75 1801Z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariableDistributedLoadW);
export default __webpack_public_path__ + "static/media/variable_distributed_load-w.4ecc36e0d4b213bf9a47fa58d1683b55.svg";
export { ForwardRef as ReactComponent };